import { toDate } from '@/utils/date-utils';
import { Pipe, PipeTransform } from '@angular/core';
import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInMonths,
  differenceInWeeks,
  format,
  isSameDay,
} from 'date-fns';

const formatPast = (amount: number, singular: string, plural: string) => {
  return `vor ${amount} ${amount === 1 ? singular : plural}`;
};

@Pipe({
  standalone: false,
  name: 'relativeDate',
})
export class RelativeDatePipe implements PipeTransform {
  transform(value: string | Date): string {
    const now = new Date();
    const date = toDate(value);
    if (date < now) {
      return this.pastDate(date);
    } else {
      return this.futureDate(date);
    }
  }

  private pastDate(date: Date): string {
    const now = new Date();
    const months = differenceInMonths(now, date);
    const weeks = differenceInWeeks(now, date);
    const days = differenceInDays(now, date);
    const hours = differenceInHours(now, date);
    const minutes = differenceInMinutes(now, date);

    if (hours === 0) {
      return formatPast(minutes, 'Minute', 'Minuten');
    } else if (days === 0) {
      return formatPast(hours, 'Stunde', 'Stunden');
    } else if (weeks === 0) {
      return formatPast(days, 'Tag', 'Tagen');
    } else if (months === 0) {
      return formatPast(weeks, 'Woche', 'Wochen');
    } else {
      return formatPast(months, 'Monat', 'Monaten');
    }
  }

  private futureDate(date: Date): string {
    const now = new Date();
    if (isSameDay(date, now)) {
      return format(date, 'HH:mm');
    }
    const difference = differenceInDays(date, now);
    switch (difference) {
      case 1:
        return `Morgen, ${format(date, 'HH:mm')}`;
      case 2:
        return `Übermorgen, ${format(date, 'HH:mm')}`;
      default:
        return format(date, 'dd.MM.yyyy, HH:mm');
    }
  }
}
